import { getTOKEN, getUserData } from "@/api/page.js";

export function getToken() {
  //获取token
  return new Promise((resolve, err) => {
    getTOKEN({
      // 使用环境变量配置的默认手机号和密码
      // 可在 .env.development 文件中修改 VUE_APP_DEFAULT_MOBILE 和 VUE_APP_DEFAULT_PASSWORD
      mobile: process.env.VUE_APP_DEFAULT_MOBILE,
      password: process.env.VUE_APP_DEFAULT_PASSWORD,
    })
      .then((res) => {
        window.localStorage.setItem("CT_APP_TOKEN", res.data.data.accessToken);
        initUser().then((suc) => {
          return resolve(suc);
        });
      })
      .catch(() => {
        return err(false);
      });
  });
}

export function delAndroidToken() {
  window.localStorage.removeItem("AndroidToken");
}

// 获取手机传的Token
export function getAndroidToken(value) {
  window.localStorage.setItem("AndroidToken", value);
}

// 获取用户信息
export function initUser() {
  return new Promise((resolve) => {
    getUserData().then((res) => {
      window.localStorage.setItem("UserData", JSON.stringify(res.data));
      resolve(res);
    });
  });
}
